import { render, staticRenderFns } from "./ComponentEditor.vue?vue&type=template&id=78ec1576&scoped=true&"
import script from "./ComponentEditor.vue?vue&type=script&lang=js&"
export * from "./ComponentEditor.vue?vue&type=script&lang=js&"
import style0 from "./ComponentEditor.vue?vue&type=style&index=0&id=78ec1576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec1576",
  null
  
)

export default component.exports